import getThemeMerger from 'util/getThemeMerger'

export default getThemeMerger((currentTheme) => ({
  overrides: {
    MuiTypography: {
      h5: {
        lineHeight: '1.34em',
        letterSpacing: 0.2,
        color: currentTheme.palette.primary.main,
      },
      h6: {
        fontWeight: 700,
        lineHeight: '1.2em',
        color: currentTheme.palette.primary.main,
      },
      overline: {
        fontWeight: 500,
      },
      body1: {
        textAlign: 'left',
        letterSpacing: 0.5,
        color: currentTheme.palette.tertiary.darkGrey,
      },
    },
    MuiButton: {
      outlined: {
        border: `1px solid ${currentTheme.palette.primary.main}`,
      },
      endIcon: {
        marginLeft: currentTheme.spacing(1.375),
      },
    },
    MuiDivider: {
      root: {
        margin: `${currentTheme.spacing(4)}px 0`,
      },
    },
  },
}))
